import styled from 'styled-components';
import { Box } from '@flexisaf/flexibull2';

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20rem 0;
`;

export const FormBox = styled(Box)`
  --form-accent: ${({ theme }) => theme?.PrimaryColor || '#825efb'};
  opacity: 1;
  background: #f6f4fa;
  min-height: 100vh;
  box-sizing: border-box;

  & .flex-render-form-name {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin: 0 0 1rem;
    padding: 0.9rem 1.15rem;
    background: #fff;
    border: 1px solid #ebe7f3;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(47, 42, 58, 0.04);

    & > span {
      font-size: 0.68rem;
      font-weight: 600;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #8a8494;
    }

    & > h2 {
      margin: 0;
      padding: 0;
      font-size: 1.15rem;
      font-weight: 700;
      letter-spacing: -0.02em;
      line-height: 1.3;
      color: #2f2a3a;
    }
  }

  /* Avoid duplicate headers if package + page both render the name */
  & .flex-render-form-name ~ * .flex-render-form-name {
    display: none !important;
  }

  & .flexi-layout {
    min-height: max-content;
    max-width: 1100px;
    margin: 0 auto;
    padding: 1rem 1.25rem 7rem;
    box-sizing: border-box;

    & .flexi-wizard {
      padding-bottom: 0;
      margin: 0 !important;
      max-width: none !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: visible !important;
      position: relative;

      /* Stock flexibull title is an absolute radio pill — hide it */
      & > .flexi-wizard-title {
        display: none !important;
      }

      & > .flexi-wizard-wrapper,
      & .flexi-wizard-wrapper {
        display: grid !important;
        grid-template-columns: minmax(200px, 240px) minmax(0, 1fr) !important;
        grid-gap: 1.25rem !important;
        padding: 0.5rem 0 1rem !important;
        align-items: start !important;
        position: relative;
      }

      & .flexi-wizard-left {
        position: sticky !important;
        top: 1rem;
        align-self: start;
        z-index: 2;
        height: auto !important;
        pointer-events: auto !important;
        margin: 0 !important;

        & .flexi-wizard-progress {
          width: 100%;
          background: #fff;
          border: 1px solid #ebe7f3;
          border-radius: 14px;
          padding: 1rem 0.75rem;
          box-shadow: 0 6px 18px rgba(47, 42, 58, 0.05);
          transform: none !important;
        }
      }

      & .flexi-wizard-right {
        margin-top: 0 !important;
        padding: 0 !important;
        min-width: 0;
        position: relative;
        z-index: 1;
      }
    }
  }

  /* Section surface inside the modal */
  & .flex-render-section {
    margin: 0 0 1rem !important;
    padding: 1.25rem 1.35rem 1rem !important;
    background: #fff !important;
    border: 1px solid #ebe7f3 !important;
    border-radius: 14px !important;
    box-shadow: 0 8px 24px rgba(47, 42, 58, 0.05) !important;
  }

  & .flex-render-section-header {
    border-bottom: 1px solid #ebe7f3 !important;
    padding-bottom: 0.85rem !important;
    margin-bottom: 0.65rem !important;
  }

  & .flex-render-section-header h3 {
    margin: 0 0 0.25rem !important;
    padding: 0 0 0 0.7rem !important;
    border-left: 3px solid var(--form-accent, #825efb);
    font-size: 1.15rem !important;
    font-weight: 700 !important;
    letter-spacing: -0.015em;
    text-transform: none !important;
    color: #2f2a3a !important;
  }

  & .flex-render-section-body {
    padding: 0.25rem 0 0 !important;
  }

  & .flex-render-row {
    margin-top: 0.35rem !important;
    padding: 0.35rem 0 !important;
    grid-gap: 0.85rem 1rem !important;
  }

  & .flex-render-col .flexi-label-wrapper label {
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    letter-spacing: 0.04em;
    text-transform: uppercase !important;
    color: #6a6378 !important;
  }

  & .flex-render-col .flexi-input,
  & .flex-render-col textarea,
  & .flex-render-col .flexi__control {
    border: 1px solid #d9d3e5 !important;
    border-radius: 8px !important;
    background: #fff !important;
    min-height: 42px;
    box-shadow: none !important;
  }

  & .flex-render-col .flexi-input:focus,
  & .flex-render-col textarea:focus,
  & .flex-render-col .flexi__control--is-focused {
    border-color: var(--form-accent, #825efb) !important;
    box-shadow: 0 0 0 3px rgba(130, 94, 251, 0.14) !important;
    background: #fff !important;
  }

  & .flex-render-section > div:last-child:has(.flexi-button) {
    display: flex;
    justify-content: flex-end;
    gap: 0.55rem;
    margin-top: 0.9rem !important;
    padding-top: 0.85rem;
    border-top: 1px solid #ebe7f3;
  }

  & .save-continue {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.75rem;
    padding: 0.9rem 1.5rem;
    border-top: 1px solid #ebe7f3;
    background: rgba(255, 255, 255, 0.94) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 -8px 24px rgba(47, 42, 58, 0.06);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;

    @media (max-width: 800px) {
      padding: 0.85rem 1rem 1.25rem;
    }

    & .save-button {
      font-family: 'Inter', system-ui, sans-serif;
      border-radius: 10px !important;
      font-weight: 600;
    }
  }

  @media (max-width: 800px) {
    & .flexi-layout {
      padding: 0.75rem 0.75rem 7.5rem;

      & .flexi-wizard {
        & > .flexi-wizard-wrapper,
        & .flexi-wizard-wrapper {
          grid-template-columns: 1fr !important;
        }

        & .flexi-wizard-left {
          position: relative !important;
          top: 0;
        }
      }
    }
  }
`;

export const FormWrapper = styled(Box)`
  &.form-preview {
    box-sizing: border-box;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    background: transparent;
    padding: 1rem 1.25rem 2.5rem;

    .preview-hero {
      padding: 22px 24px 20px;
      border-radius: 18px;
      background: linear-gradient(165deg, #faf9fc 0%, #f3f0f8 100%);
      border: 1px solid #ebe7f2;
      box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    }

    .preview-eyebrow {
      font-size: 11px;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: ${(p) => p.theme.PrimaryColor || '#5b3cc4'};
      margin-bottom: 6px;
    }

    .preview-title {
      font-size: 22px;
      line-height: 1.25;
      color: #1c1a22;
      letter-spacing: -0.02em;
      margin: 0;
    }

    .preview-subtitle {
      margin-top: 6px;
      font-size: 13px;
      line-height: 1.45;
      color: #6b6575;
    }

    .preview-identity {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 20px;
      margin-top: 20px;
      padding-top: 18px;
      border-top: 1px solid #e6e1ed;
    }

    .preview-identity-copy {
      min-width: 0;
      flex: 1;
    }

    .preview-name {
      font-size: 18px;
      line-height: 1.3;
      color: #1c1a22;
      letter-spacing: -0.01em;
    }

    .preview-app {
      margin-top: 6px;
      font-size: 13px;
      color: ${(p) => p.theme.PrimaryColor || '#5b3cc4'};
    }

    .preview-course {
      margin-top: 8px;
      font-size: 13px;
      color: #3f3a48;
      text-transform: uppercase;
      letter-spacing: 0.02em;

      span {
        display: inline-block;
        margin-right: 6px;
        font-weight: 600;
        color: #8a8494;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        font-size: 11px;
      }
    }

    .preview-tags {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }

    .preview-passport {
      flex-shrink: 0;
      width: 112px;
      padding: 6px;
      border-radius: 14px;
      background: #fff;
      border: 1px solid #e6e1ed;
      box-shadow: 0 8px 24px rgba(40, 30, 70, 0.08);

      img {
        display: block;
        width: 100%;
        height: auto;
        border-radius: 10px;
        object-fit: cover;
      }
    }

    .preview-body {
      margin-top: 22px;
    }

    .preview-section {
      margin: 0 0 18px;
      padding: 18px 18px 16px;
      border-radius: 16px;
      background: #fff;
      border: 1px solid #ebe7f2;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .preview-section-title {
      margin: 0 0 4px;
      padding-bottom: 10px;
      border-bottom: 1px solid #f0ecf5;
      font-size: 12px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #5c5668;
    }

    .form-grid {
      margin: 0;
      width: 100%;
      align-items: stretch;
      grid-gap: 10px !important;
      row-gap: 10px !important;
      column-gap: 10px !important;
    }

    .single-form {
      margin: 0;
      height: 100%;
      min-width: 0;
      box-sizing: border-box;
      padding: 12px 14px;
      border: none;
      border-radius: 12px;
      background: #f7f5fb;
    }

    .field-label {
      font-size: 11px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #8a8494;
      margin-bottom: 6px;
    }

    .field-value {
      font-size: 14px;
      line-height: 1.45;
      color: #2a2633;
      word-break: break-word;

      p {
        margin: 0;
      }
    }

    .preview-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 8px;
      padding: 16px 4px 0;
    }

    @media (max-width: 720px) {
      .preview-identity {
        flex-direction: column-reverse;
      }

      .preview-passport {
        width: 96px;
      }

      .preview-actions {
        justify-content: stretch;

        button {
          flex: 1;
        }
      }
    }
  }

  & .applicant-info {
    margin-top: 0;
  }

  padding-bottom: 12px;

  .form-actions,
  .print-form {
    @media print {
      display: none;
    }
  }
`;
